var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "False"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.188 5.08963L12.4695 8.79468L8.76453 5.07617L4.51346 9.31213L8.21851 13.0322L4.5 16.7372L8.73596 20.9867L12.4545 17.2816L16.1595 21.0001L20.4105 16.7656L16.7055 13.0457L20.424 9.3407L16.188 5.08963Z",
    fill: "#EA4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.1861d35de1aec545cb58a3711b74b99a.svg";
export { ForwardRef as ReactComponent };